<!-- Start Header Area -->
<header class="header-area" >
    <div class="top-header">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <ul class="top-header-contact-info">
                        <li>
                            <i class='bx bx-phone-call'></i>
                            <span>{{contactSupport}}</span>
                            <a href="tel:{{setting.phone}}}">{{setting.phone}}</a>
                        </li>
                        <!-- <li>
                            <i class='bx bx-map'></i>
                            <span>{{ourLocation}}</span>
                            <a href="#">{{setting.address}}</a>
                        </li> -->
                        <li>
                            <i class='bx bx-envelope'></i>
                            <span>{{contactEmail}}</span>
                            <a href="mailto:{{setting.email}}">{{setting.email}}</a>
                        </li>
                    </ul>
                </div>

                <!-- <div class="col-lg-4 col-md-4">
                    <div class="top-header-btn" *ngIf="isLoggedIn; else elseBlock">
                        <a [routerLink]="['/page/my-account/courses']" class="default-btn"><i
                                class='bx bxs-user icon-arrow before'></i><span class="label">{{myAccount}}</span><i
                                class="bx bxs-user icon-arrow after"></i></a>
                    </div>
                    <ng-template #elseBlock>
                        <div class="top-header-btn">
                            
                            <a [routerLink]="['/login']" class="default-btn"><i
                                    class='bx bx-log-in icon-arrow before'></i><span class="label">{{login}}</span><i
                                    class="bx bx-log-in icon-arrow after"></i></a>

                            <a [routerLink]="['/register']" class="default-btn" style="margin-left:10px;"><i
                                    class='bx bx-log-in-circle icon-arrow before'></i><span
                                    class="label">{{register}}</span><i
                                    class="bx bx-log-in-circle icon-arrow after"></i></a>
                        </div>
                    </ng-template>

                </div>  -->
               
                <div id="header-right" class="col-lg-4 col-md-4" *ngIf="isCheckedAuth;">
                        <ul class="top-header-login-register" *ngIf="isLoggedIn; else elseBlock">
                            <li><a [routerLink]="['/my-account/courses']"><i class='bx bxs-user'></i> {{myAccount}}</a>
                            </li>
                            <li id="language-mobile">
                                <a href="javascript:;" (click)="onSwitchLanguage()"> <img src="{{flagImage}}" class="shadow"
                                        alt="image"></a>
                            </li>
                        </ul>
                        <ng-template #elseBlock>
                            <ul class="top-header-login-register">
                                <li><a [routerLink]="['/login']"><i class='bx bx-log-in'></i> {{login}}</a></li>
                                <li><a [routerLink]="['/register']"><i class='bx bx-log-in-circle'></i> {{register}}</a>
                                </li>
                                <li id="language-mobile">
                                    <a href="javascript:;" (click)="onSwitchLanguage()"> <img src="{{flagImage}}"
                                            class="shadow" alt="image"></a>
                                </li>
                            </ul>
                        </ng-template>
                </div>


            </div>
        </div>
    </div>

    <app-navbar></app-navbar>
    

</header>
<!-- End Header Area -->


<router-outlet (activate)="onActivate($event)" ></router-outlet>

<app-footer [setting]="setting"></app-footer>



